<!-- 订单评论 -->
<template>
  <div>
    <el-dialog
      title="投诉建议详情"
      :visible.sync="dialogVisible"
      width="50%"
      :rules="rules"
      :before-close="handleClose"
    >
      <el-form size="small" :model="formData" class="demo-form-inline" ref="formRef">
        <el-row>
          <el-col :span="12">
            <el-form-item label="投诉来源：">
              <span
                >{{ suggestionDetail.createBy
                }}<span v-if="suggestionDetail.source"
                  >（{{ formatSource(suggestionDetail.source) }}）</span
                ></span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <span>{{ suggestionDetail.phone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="投诉时间：">
          <span>{{ suggestionDetail.createTime }}</span>
        </el-form-item>
        <el-form-item label="投诉反馈：">
          <span>{{ suggestionDetail.adviseInfo }}</span>
          <ImgUpload
            v-model="suggestionDetail.image"
            :limit="5"
            :isEdit="true"
          ></ImgUpload>
        </el-form-item>
        <div v-if="suggestionDetail.status == 0">
          <el-form-item label="投诉回复：">
            <el-input
              v-model.trim="formData.reply"
              type="textarea"
              :row="2"
              maxlength="200"
              style="width: 86%"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片：">
            <ImgUpload v-model="formData.replyImage" :limit="5"></ImgUpload>
            <div v-if="formData.replyImage.length > 0">
              图片格式为jpg或png，图片大小不得超过5M
            </div>
          </el-form-item>
        </div>
        <div v-if="suggestionDetail.status == 1">
          <el-form-item label="回复时间：">
            <span>{{ suggestionDetail.replyTime }}</span>
          </el-form-item>
          <el-form-item label="投诉回复：">
            <span>{{ suggestionDetail.reply }}</span>
            <ImgUpload
              v-if="suggestionDetail.replyImage && suggestionDetail.replyImage.length"
              v-model="suggestionDetail.replyImage"
              :isEdit="true"
            ></ImgUpload>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ status == 1 ? "关闭" : "取消" }}</el-button>
        <el-button type="primary" @click="submit" v-if="status == 0">确定回复</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { adviseInfo, adviseReply } from "@/api/suggestion";
import ImgUpload from "@/components/imgUpload";

export default {
  components: { ImgUpload },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      dialogVisible: false,
      status: null,
      formData: {
        reply: "",
        replyImage: [],
      },
      rules: [],
      imageList: [],
      replyImageList: [],
      suggestionDetail: {},
    };
  },
  methods: {
    handleClose() {
      this.formData = {
        reply: "",
        replyImage: [],
      };
      this.suggestionDetail = {};
      this.dialogVisible = false;
    },
    init(id, status) {
      this.dialogVisible = true;
      this.status = status;
      this.getDetail(id);
    },
    getDetail(id) {
      adviseInfo(id).then((res) => {
        res.image && (res.image = res.image.split(","));
        res.replyImage && (res.replyImage = res.replyImage.split(","));
        this.suggestionDetail = res;
        this.$emit("refreshCornerMark");
      });
    },
    submit() {
      let _replyImage = null;
      const { reply, replyImage } = this.formData;
      if (replyImage.length) {
        _replyImage = replyImage.join(",");
      }
      const _data = {
        id: this.suggestionDetail.id,
        reply,
        replyImage: _replyImage,
      };
      adviseReply(_data).then((res) => {
        this.$message.success("操作成功");
        this.$emit("refreshList");
        this.handleClose();
      });
    },
    formatSource(source) {
      let str = "";
      switch (source) {
        case "1":
          str = "客户PC端";
          break;
        case "2":
          str = "商户端";
          break;
        case "4":
          str = "客户APP端";
          break;
        case "5":
          str = "业务APP端";
          break;
      }
      return str;
    },
  },
};
</script>
<style scoped></style>
